import { getTenantInfoAPI } from 'api/endpoints/brandFeed/brandFeed.api';
import { ITranslate } from 'interfaces/general.interface';
import * as BTypes from './tenantFeed.types';
import { videoType } from 'views/pages/main/multimediaPage/components/constants';
import { IBodyMultimediaFetch } from 'interfaces/multimedia.interface';
import { findMultimediaAPI } from 'api/endpoints/multimedia/multimedia.api';
import { notificationErr } from 'views/components/notification';
import { tenantFeedError } from 'utils/errorCodes';
import { IBodyProductSearch } from 'interfaces/catalog.interface';
import { getAndOrderImagesCatalog } from 'contexts/catalog/reducer/catalog.actions';

export async function getTenantFeedAction({
  dispatch,
  tenantId,
  countryId,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  tenantId: string;
  countryId: string;
  token: string;
  translate: ITranslate;
}): Promise<boolean> {
  dispatch({
    type: BTypes.SET_IS_LOADING_SET_TENANT_FEED,
    payload: true,
  });
  try {
    const getTenantFetch = await getTenantInfoAPI({
      tenantId,
      countryId,
      token,
    });
    if (getTenantFetch.response.status === 200 && getTenantFetch.data.bio) {
      dispatch({
        type: BTypes.SET_TENANT_FEED,
        payload: getTenantFetch.data,
      });
      return true;
    }
    return false;
  } catch (error) {
    notificationErr(tenantFeedError.getTenantFeed_001, translate);
    return false;
  } finally {
    dispatch({
      type: BTypes.SET_IS_LOADING_SET_TENANT_FEED,
      payload: false,
    });
  }
}

export async function getProfileProductsByBrandAction({
  dispatch,
  brandId,
  translate,
  token,
}: {
  dispatch: React.Dispatch<any>;
  brandId: string;
  translate: ITranslate;
  token: string;
}): Promise<boolean> {
  const bodyProductSearch: IBodyProductSearch = {
    options: {
      brand_id: [brandId],
      client_id: [],
      csv_format: false,
      profile: true,
      favorite: null,
      with_images: null,
      search: [],
      language_id: '',
      order: [],
      group: [],
      limit: 10,
      index: 0,
    },
    filter: {
      reference: [],
      color: [],
      season: [],
      segmentation: [],
      division: [],
      family: [],
      gender: [],
      pvi: [],
      pvpr: [],
      tag: [],
      tier: [],
    },
  };
  try {
    const products = await getAndOrderImagesCatalog({
      dispatch,
      body: bodyProductSearch,
      signal: undefined,
      token,
    });
    if (products) {
      dispatch({
        type: BTypes.GET_PRODUCTS_BY_BRAND,
        payload: products.data,
      });
      return true;
    }
    return false;
  } catch (err: any) {
    notificationErr(tenantFeedError.getAndOrderImagesCatalog_001, translate);
    return false;
  }
}

export async function getProfileVideosByBrandAction(
  dispatch: React.Dispatch<any>,
  brandId: string,
  signal: AbortSignal | undefined,
  translate: ITranslate,
  token: string
): Promise<boolean> {
  try {
    const bodyMultimediaVideosFetch: IBodyMultimediaFetch = {
      options: {
        profile: true,
        brand_id: [brandId],
        multimedia_type: [videoType],
        search: [],
        limit: 20,
        index: 0,
      },
      filter: {
        tag: [],
        product: [],
        division: [],
        gender: [],
        country: [],
        season: [],
      },
    };
    const mediaFetch = await findMultimediaAPI(bodyMultimediaVideosFetch, signal, token);
    const mediaData = mediaFetch.data;
    if (mediaFetch.response.status === 200) {
      dispatch({
        type: BTypes.GET_VIDEOS_BY_BRAND,
        payload: mediaData,
      });
      return true;
    }
    return false;
  } catch (err: any) {
    if (err.code !== 20) {
      notificationErr(tenantFeedError.getVideosByBrand_001, translate);
    }
    return false;
  }
}
